import { useNavigate } from "#routers/hooks";
import { displayValueWithUnknownDataType } from "#src/utils/display";
import { Info, Link } from "@validereinc/common-components";
import classNames from "classnames/bind";
import * as PropTypes from "prop-types";
import React from "react";
import "./SummaryInformation.module.scss";
import styles from "./SummaryInformation.module.scss";

const cx = classNames.bind(styles);

/** @deprecated use the SummaryPanel from common-components instead */
const SummaryInformation = ({
  title,
  description,
  value,
  style,
  titleStyle,
  className,
  type = "horizontal",
  capitalized,
  spaceBetween,
  link,
  suppress = false,
  allowWrap = false,
  isLoading = false,
  isStatusPanel = false,
}) => {
  const navigate = useNavigate();

  const valueInlineStyle = {
    textTransform: capitalized ? "capitalize" : "initial",
    whiteSpace: allowWrap ? "normal" : "nowrap",
    fontSize: isStatusPanel ? "14px" : "16px",
  };

  if (link && value) {
    value = (
      <Link
        label={value}
        // @ts-expect-error legacy opshub typing
        style={valueInlineStyle}
        onClick={() => navigate({ pathname: link })}
      />
    );
  }

  return (
    <section
      className={cx("summaryInformation", className, {
        summaryInformation__vertical: type === "vertical",
        summaryInformation__spaceBetween: spaceBetween,
      })}
      style={style}
    >
      <div
        className={cx(
          "summaryInformation__title",
          isStatusPanel && "summaryInformation__title--small"
        )}
        style={titleStyle}
      >
        {title}
        {description && <Info content={description} />}
      </div>

      {type === "horizontal" && !spaceBetween ? ": " : null}

      <div
        className={cx("summaryInformation__value", {
          skeleton: isLoading,
        })}
        // @ts-expect-error legacy opshub typing
        style={valueInlineStyle}
        data-hj-suppress={suppress}
      >
        {displayValueWithUnknownDataType(value)}
      </div>
    </section>
  );
};

SummaryInformation.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  style: PropTypes.object,
  titleStyle: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(["horizontal", "vertical"]),
  capitalized: PropTypes.bool,
  spaceBetween: PropTypes.bool,
  link: PropTypes.string,
  allowWrap: PropTypes.bool,
  /** If true, will block out summary information value for hotjar recordings */
  suppress: PropTypes.string,
  isLoading: PropTypes.bool,
  isStatusPanel: PropTypes.bool,
};

export default SummaryInformation;
